// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3_zby","options":"AnswerScale_options__EaqA-","selected":"AnswerScale_selected__1_tjp"};